"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formSelector = exports.validSelector = exports.pristineSelector = exports.validatingSelector = exports.valuesSelector = exports.inputsSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _some2 = _interopRequireDefault(require("lodash/some"));

var _reselect = require("reselect");

var _helpers = require("./helpers");

var getValuesFromInputs = function getValuesFromInputs(inputs) {
  return (0, _reduce2.default)(inputs, function (acc, input, key) {
    return (0, _objectSpread3.default)({}, acc, (0, _defineProperty2.default)({}, key, input.value));
  }, {});
};

var areInputsValidating = function areInputsValidating(inputs) {
  return (0, _some2.default)(inputs, function (input) {
    return input.validating;
  });
};

var areInputsPristine = function areInputsPristine(inputs) {
  return !(0, _some2.default)(inputs, function (input) {
    return !input.pristine;
  });
};

var areInputsValid = function areInputsValid(inputs) {
  return !(0, _helpers.inputsWithErrors)(inputs);
};

var inputsSelector = function inputsSelector(inputConfig, inputKeys) {
  return function (state) {
    return (0, _helpers.getInputsFromState)(inputConfig, state, inputKeys);
  };
};

exports.inputsSelector = inputsSelector;

var valuesSelector = function valuesSelector(inputConfig, inputKeys) {
  return (0, _reselect.createSelector)(inputsSelector(inputConfig, inputKeys), getValuesFromInputs);
};

exports.valuesSelector = valuesSelector;

var validatingSelector = function validatingSelector(inputConfig, inputKeys) {
  return (0, _reselect.createSelector)(inputsSelector(inputConfig, inputKeys), areInputsValidating);
};

exports.validatingSelector = validatingSelector;

var pristineSelector = function pristineSelector(inputConfig, inputKeys) {
  return (0, _reselect.createSelector)(inputsSelector(inputConfig, inputKeys), areInputsPristine);
};

exports.pristineSelector = pristineSelector;

var validSelector = function validSelector(inputConfig, inputKeys) {
  return (0, _reselect.createSelector)(inputsSelector(inputConfig, inputKeys), areInputsValid);
};

exports.validSelector = validSelector;

var formSelector = function formSelector(inputConfig, inputKeys) {
  return (0, _reselect.createSelector)(valuesSelector(inputConfig, inputKeys), validatingSelector(inputConfig, inputKeys), pristineSelector(inputConfig, inputKeys), validSelector(inputConfig, inputKeys), function (values, validating, pristine, valid) {
    return {
      values: values,
      validating: validating,
      pristine: pristine,
      valid: valid
    };
  });
};

exports.formSelector = formSelector;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/selectors.js
// module id = 468
// module chunks = 0